const convertBoolToString = (bool) => {
  if (bool === null || bool === undefined) return ''

  return bool ? 'Sim' : 'Não'
}

export default convertBoolToString
